import { createContext, useContext, useState } from "react";
import { ContactGate } from "../components/ContactGate";

const ContactContext = createContext({
  openGate: (message) => {},
});

export const useContact = () => useContext(ContactContext);

export const ContactProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [initialMessage, setInitialMessage] = useState("");

  const openGate = (message) => {
    setInitialMessage(message || "");
    setIsOpen(true);
  };

  return (
    <ContactContext.Provider value={{ openGate }}>
      {children}
      <ContactGate
        open={isOpen}
        onOpenChange={setIsOpen}
        initialMessage={initialMessage}
      />
    </ContactContext.Provider>
  );
};
